import addresses from 'constants/contract'
import { GRAPH_API_PREDICTION_BTC, GRAPH_API_PREDICTION_ETH, BTCK, ETH, MJT } from 'constants/index'
import { getAddress } from 'utils/addressHelpers'
import { BigNumber } from '@ethersproject/bignumber'

const DEFAULT_MIN_PRICE_USD_DISPLAYED = BigNumber.from(10000)

export default {
  BTC: {
    address: getAddress(addresses.predictionsBTC),
    api: GRAPH_API_PREDICTION_BTC,
    chainlinkOracleAddress: getAddress(addresses.chainlinkOracleBTC),
    minPriceUsdDisplayed: DEFAULT_MIN_PRICE_USD_DISPLAYED,
    displayedDecimals: 4,
    token: BTCK[process.env.REACT_APP_CHAIN_ID],
    payToken: MJT[process.env.REACT_APP_CHAIN_ID],
  },
  ETH: {
    address: getAddress(addresses.predictionsETH),
    api: GRAPH_API_PREDICTION_ETH,
    chainlinkOracleAddress: getAddress(addresses.chainlinkOracleETH),
    minPriceUsdDisplayed: DEFAULT_MIN_PRICE_USD_DISPLAYED,
    displayedDecimals: 4,
    token: ETH[process.env.REACT_APP_CHAIN_ID],
    payToken: MJT[process.env.REACT_APP_CHAIN_ID],
  },
}
